module.exports = __webpack_public_path__ + "img/图片13.d68a67a7.png";